import { emptyRichText, type Sticky } from '../../shared/types.ts';
import { newId } from '../../shared/ids.ts';
import type { Editor } from '../editor.ts';
import type { Tool, WorldPointerEvent } from './types.ts';

const SIZE = 200;

/**
 * Click to place a sticky centred on the pointer and start typing on it.
 * Creation and the first edit form one undo step.
 */
export class StickyTool implements Tool {
  cursor = 'crosshair';
  private readonly ed: Editor;
  private createdId: string | null = null;

  constructor(editor: Editor) {
    this.ed = editor;
  }

  onPointerDown(e: WorldPointerEvent): void {
    const ed = this.ed;
    const obj: Sticky = {
      id: newId(), type: 'sticky',
      x: e.x - SIZE / 2, y: e.y - SIZE / 2, w: SIZE, h: SIZE, rotation: 0,
      z: ed.zKeysOnTop(1)[0]!, createdBy: ed.userId,
      color: ed.stickyColor, text: emptyRichText(),
    };
    ed.beginGesture();
    ed.apply([{ t: 'create', obj }]);
    this.createdId = obj.id;
  }

  onPointerMove(): void {}

  onPointerUp(): void {
    const id = this.createdId;
    if (!id) return;
    this.createdId = null;
    const ed = this.ed;
    ed.setTool('select');
    ed.setSelection([id]);
    ed.startTextEdit(id, { gesture: true, isNew: true, caret: 'end' });
  }

  onCancel(): void {
    if (!this.createdId) return;
    this.createdId = null;
    this.ed.cancelGesture();
  }
}
